export default __webpack_public_path__ + "static/media/light-bulb.bf48cd02.svg";